import { render, staticRenderFns } from "./cancellation-home.vue?vue&type=template&id=16272c00&scoped=true&"
import script from "./cancellation-home.vue?vue&type=script&lang=js&"
export * from "./cancellation-home.vue?vue&type=script&lang=js&"
import style0 from "./cancellation-home.vue?vue&type=style&index=0&id=16272c00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16272c00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
